import { ChangeDetectionStrategy, Component, ElementRef } from '@angular/core';
import { AgHeaderComponent } from '../ag-header.component';
import { IHeaderParams } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LetDirective } from '@ngrx/component';
import { ColumnSortingButtonComponent } from '../../column-sorting-button/column-sorting-button.component';
import { MatIcon } from '@angular/material/icon';
import { SortingEnum } from '../../../locations-skeleton/enums/sorting-enum';

export interface BasicHeaderParams extends IHeaderParams {}

@Component({
  selector: 'app-ag-basic-header',
  templateUrl: './ag-basic-header.component.html',
  styleUrl: './ag-basic-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    LetDirective,
    ColumnSortingButtonComponent,
    MatIcon,
  ],
})
export class AgBasicHeaderComponent extends AgHeaderComponent<BasicHeaderParams>{

  public readonly viewModel$: Observable<{
    params: BasicHeaderParams,
    sortDirection: SortingEnum,
    sortIndex: number
  }> = this.params$
      .pipe(map((params) => ({
        params,
        sortIndex: params?.column?.getSortIndex(),
        sortDirection: params?.column?.getSort() === 'asc' ?
            SortingEnum.ASCENDING :
            params?.column?.getSort() === 'desc' ?
                SortingEnum.DESCENDING :
                SortingEnum.NONE
      })));

  constructor(elementRef: ElementRef) {
    super(elementRef)
  }

  onSortRequested(event: MouseEvent, params: BasicHeaderParams) {
    super.onSortRequested(event, params);
    // Setting sort does not trigger the header component's refresh() method for some reason...
    // (it does trigger the sortChanged event on the grid component though...),
    // so manually refresh all headers to force params update in order to get new sort state.
    // In case of stutters, listen to the grid event instead of re-rendering headers.
    requestAnimationFrame(() => // wait until the click animation finishes
        params.api.refreshHeader());
  }

}
